import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "PDFOnlineTypeBlockTestResults" }
const _hoisted_2 = { class: "TestResultGridContainer" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "EmptyGridCell" }, null, -1)
const _hoisted_5 = { class: "KindOfSample" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "EmptyGridCell" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "EmptyGridCell"
}
const _hoisted_10 = {
  key: 2,
  class: "Images"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFRegion = _resolveComponent("PDFRegion")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PDFOnlineTypeBlockWrap = _resolveComponent("PDFOnlineTypeBlockWrap")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkedSamples, (chunk, index) => {
    return (_openBlock(), _createBlock(_component_PDFOnlineTypeBlockWrap, {
      key: index,
      titles: _ctx.titles,
      encodedTitles: _ctx.encodedTitles,
      disableContinued: _ctx.disable.continued,
      disableToBeContinued: _ctx.disable.toBeContinued
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (index === 0)
            ? (_openBlock(), _createBlock(_component_PDFRegion, {
                key: 0,
                heading: _ctx.mixWB('TEST_RESULTS')
              }, null, 8, ["heading"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oType.getTestResultsTexts(), (textItem) => {
            return (_openBlock(), _createElementBlock("p", {
              key: textItem.text
            }, _toDisplayString(textItem.text), 1))
          }), 128)),
          _createElementVNode("div", _hoisted_2, [
            (chunk.some((x) => x.options.isAalholmSlotDustSample))
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.mixWB('W: Resultatet for prøven foreligger som bilag, særskilt fra dette dokument. Se henvisningen i bemærkninger.')), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "TestResultGrid",
                  style: _normalizeStyle({ gridTemplateColumns: `repeat(${chunk.length + 1}, 175px)` })
                }, [
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (sample, sIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: sample.hashID + sIndex,
                      class: _normalizeClass(["SampleTitle", _ctx.results[sIndex].overallResultClass])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFullSampleTitle(sample)), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(sample.getKindOfSampleText()), 1)
                    ], 2))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cleanAnalysisTestsAsArray, (analysisTest, rIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: analysisTest.id
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(rIndex % 2 ? 'Even' : 'Odd')
                      }, _toDisplayString(_ctx.mixWB(analysisTest.translation)), 3),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (sample, sIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: sample.hashID + sIndex
                        }, [
                          (!['existing', 'postponed'].includes(sample.sampleType))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([
                        _ctx.results[sIndex][analysisTest.id].class,
                        {
                          'Even': !_ctx.results[sIndex][analysisTest.id].result && rIndex % 2,
                          'Odd': !_ctx.results[sIndex][analysisTest.id].result && !(rIndex % 2),
                        }])
                              }, _toDisplayString(_ctx.results[sIndex][analysisTest.id].text), 3))
                            : (rIndex === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (sample.sampleType === 'postponed')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "TextFeedback",
                                        style: _normalizeStyle({
                        gridRow: `2 / ${_ctx.cleanAnalysisTestsAsArray.length + 2}`,
                        gridColumn: sIndex + 2
                      })
                                      }, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('SAMPLE_POSTPONED')), 1)
                                      ], 4))
                                    : (sample.sampleType === 'existing')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "TextFeedback",
                                          style: _normalizeStyle({
                        gridRow: `2 / ${_ctx.cleanAnalysisTestsAsArray.length + 2}`,
                        gridColumn: sIndex + 2
                      })
                                        }, [
                                          _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('EXISTING_SAMPLE_FROM_EXTERNAL_PROJECT')), 1),
                                          _createElementVNode("p", null, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('RESULT')), 1),
                                            _hoisted_6,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.results[sIndex].label), 1)
                                          ]),
                                          _createElementVNode("p", null, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('REFERENCE')), 1),
                                            _hoisted_7,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.results[sIndex].notes?.explanation), 1)
                                          ])
                                        ], 4))
                                      : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 64))
                  }), 128)),
                  (chunk.length > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_8,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (sample, sIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: sample.hashID + sIndex
                          }, [
                            (_ctx.getImages(sample).length)
                              ? (_openBlock(), _createBlock(_component_Image, {
                                  key: 0,
                                  context: _ctx.context,
                                  class: "SampleImage",
                                  image: _ctx.getImages(sample)[0],
                                  loading: 'eager',
                                  dimensions: { width: 175, height: 175 },
                                  transformation: 'square_400'
                                }, null, 8, ["context", "image"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9))
                          ], 64))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ], 4)),
            (chunk.length === 1 && _ctx.getImages(chunk[0]).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('IMAGES_OF_X', [chunk[0].getReferenceSample().sampleTypeID])), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getImages(chunk[0]), (image) => {
                    return (_openBlock(), _createBlock(_component_Image, {
                      key: image?.base.path,
                      context: _ctx.context,
                      image: image,
                      loading: 'eager',
                      dimensions: { width: 167, height: 167 },
                      transformation: 'square_400'
                    }, null, 8, ["context", "image"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 2
    }, 1032, ["titles", "encodedTitles", "disableContinued", "disableToBeContinued"]))
  }), 128))
}